import React from "react";
import "./reset-password.page.scoped.scss";
import { SignUpLayout } from "../../layouts/signup/sign-up.layout";
import NormalResetPasswordCompenent from "../../components/normal-reset-password/normal-reset-password.component";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../services/common/common.service";

const commonService: CommonService = new CommonService();

const ResetPasswordPage = (props: any) => {
  const [t] = useTranslation();
  commonService.setTitle(t("Case Management"));

  const token = props.match.params.id;

  return (
    <SignUpLayout>
      <NormalResetPasswordCompenent token={token} />
    </SignUpLayout>
  );
};

export default ResetPasswordPage;
